import { SVGProps } from 'react';

export function FacebookFeedShareIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <g clipPath="url(#clip0_2528_3560)">
        <path
          d="M17.3793 9.66902C17.7275 9.28726 17.7275 8.70313 17.3793 8.32137L11.5295 1.90676C10.9141 1.23197 9.7906 1.66733 9.7906 2.5806V5.38824H8.83768C6.47713 5.38824 4.25775 6.30753 2.58852 7.97676C0.919281 9.646 0 11.8654 0 14.2261V16.7104C0 17.167 0.561552 17.3847 0.869312 17.0475L1.57434 16.275C3.68028 13.9677 6.66966 12.633 9.7906 12.6027V15.4099C9.7906 16.3232 10.9141 16.7585 11.5295 16.0837L17.3793 9.66902ZM1.05482 15.2883V14.2261C1.05482 12.1472 1.86438 10.1926 3.33435 8.72259C4.80432 7.25262 6.75879 6.44307 8.83768 6.44307H10.8453V2.722L16.5664 8.99519L10.8453 15.2685V11.5475H9.89896C6.56955 11.5475 3.36786 12.9063 1.05482 15.2883Z"
          fill="#18181B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2528_3560">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
